import ApiServiceWrapper from '@/shared/api-request.service';
import { UserListResponse } from '@/modules/msw-accessmgmt/components/types';

const userListApi = {
  getUserList() {
    const reqEndPoint = 'users/get-user-list?isFromMssp=YES';
    return ApiServiceWrapper.get<UserListResponse>(reqEndPoint);
  },
  updatePermission(data: any) {
    const reqEndPoint = 'users/update-mssp-role';
    return ApiServiceWrapper.post(reqEndPoint, data);
  },
  getUserListWithRecAdded(recAdded: string) {
    const reqEndPoint = `users/get-user-list?${recAdded}`;
    return ApiServiceWrapper.get<UserListResponse>(reqEndPoint);
  },
};

export default userListApi;
